
import { defineComponent } from "vue";
import EditProfile from "@/components/Shared/ProfileView/EditProfile.vue";
import SecurityAndLogin from "@/components/Shared/ProfileView/SecurityAndLogin.vue";

export default defineComponent({
  name: "ProfileView",
  data() {
    return {
      tabs: [
        {
          name: "Profile",
          text: "Profile",
          icon: "bi-person-circle",
        },
        {
          name: "Security and Login",
          text: "Security",
          icon: "bi-shield-check",
        },
      ],
      activeTab: "Profile",
      windowWidth: window.innerWidth,
      avatar: "default_profile.png",
    };
  },
  components: {
    EditProfile,
    SecurityAndLogin,
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    setURL(image: string): string {
      const urlcheck = /^(ftp|http|https):\/\/[^ "]+$/;
      return RegExp(urlcheck).exec(image)
        ? image
        : require("@/assets/images/Shared/" + image);
    },
    setActiveTab(tab: string) {
      this.activeTab = tab;
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
});
